module.exports = __webpack_public_path__ + "img/Speedjunkies.da612305.svg";